import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import FunnelSummaryCard from "../components/FunnelSummaryCard";
import { Search, FolderKanban, Activity, Mail, Eye, MousePointerClick, BookOpen, TrendingUp } from "lucide-react";

const StatCard = ({ label, value, icon: Icon, accent, testid, to }) => {
  const content = (
    <>
      <div className="flex items-center justify-between mb-2">
        <div className="stat-label">{label}</div>
        <Icon size={18} color={accent || "var(--mv-primary)"} />
      </div>
      <div className="stat-num">{value}</div>
      {to && <div className="text-small text-muted mt-2" style={{display:"flex",alignItems:"center",gap:4}}>Apri →</div>}
    </>
  );
  if (to) return <Link to={to} className="card card-hover" style={{textDecoration:"none",color:"inherit",cursor:"pointer"}} data-testid={testid}>{content}</Link>;
  return <div className="card card-hover" data-testid={testid}>{content}</div>;
};

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/stats").then(r => setStats(r.data)); }, []);

  return (
    <div data-testid="dashboard-page">
      <div className="flex justify-between items-center mb-6">
        <div>
          <div className="h-display">Dashboard</div>
          <div className="text-muted mt-2">Visione d'insieme delle attività di lead generation</div>
        </div>
      </div>

      <FunnelSummaryCard />

      <div className="grid gap-4 mb-6" style={{gridTemplateColumns:"repeat(auto-fit, minmax(180px,1fr))"}}>
        <StatCard label="Aziende totali" value={stats?.totalCompanies ?? "—"} icon={Search} testid="stat-companies" to="/crm" />        <StatCard label="Liste lead" value={stats?.totalLists ?? "—"} icon={FolderKanban} testid="stat-lists" to="/liste" />
        <StatCard label="Analisi completate" value={stats?.analyzedCount ?? "—"} icon={Activity} testid="stat-analyzed" to="/coda" />
        <StatCard label="In coda" value={stats?.queuedCount ?? "—"} icon={Activity} accent="var(--mv-warning)" testid="stat-queued" to="/coda" />
        <StatCard label="Email inviate (30gg)" value={stats?.emailsLast30Days ?? "—"} icon={Mail} testid="stat-emails" />
        <StatCard label="Visualizzazioni report" value={stats?.publicViews ?? "—"} icon={Eye} accent="var(--mv-success)" testid="stat-views" />
        <StatCard label="Click consulenza" value={stats?.calendarClicks ?? "—"} icon={MousePointerClick} accent="var(--mv-success)" testid="stat-clicks" />
        <StatCard label="Download libro" value={stats?.bookDownloads ?? "—"} icon={BookOpen} testid="stat-books" />
      </div>

      <div className="grid gap-4" style={{gridTemplateColumns:"repeat(auto-fit, minmax(280px,1fr))"}}>
        <Link to="/ricerca" className="card card-hover" style={{textDecoration:"none",color:"inherit"}} data-testid="quick-search">
          <div className="flex items-center gap-3 mb-2"><Search size={22} color="var(--mv-primary)" /><div className="h-card">Nuova ricerca</div></div>
          <div className="text-muted text-small">Trova aziende italiane con filtri avanzati su OpenAPI.it</div>
        </Link>
        <Link to="/liste" className="card card-hover" style={{textDecoration:"none",color:"inherit"}} data-testid="quick-lists">
          <div className="flex items-center gap-3 mb-2"><FolderKanban size={22} color="var(--mv-primary)" /><div className="h-card">Vedi liste</div></div>
          <div className="text-muted text-small">Gestisci le liste di lavorazione, pre-screen, analisi profonda ed email</div>
        </Link>
        <Link to="/coda" className="card card-hover" style={{textDecoration:"none",color:"inherit"}} data-testid="quick-queue">
          <div className="flex items-center gap-3 mb-2"><Activity size={22} color="var(--mv-primary)" /><div className="h-card">Coda analisi</div></div>
          <div className="text-muted text-small">Monitora le analisi profonde in corso e quelle completate</div>
        </Link>
        <Link to="/engagement" className="card card-hover" style={{textDecoration:"none",color:"inherit"}} data-testid="quick-engagement">
          <div className="flex items-center gap-3 mb-2"><TrendingUp size={22} color="var(--mv-primary)" /><div className="h-card">Engagement</div></div>
          <div className="text-muted text-small">Open rate, click rate e bounce rate delle campagne (richiede webhook Resend configurato)</div>
        </Link>
      </div>
    </div>
  );
}
